import {
  whiteColor,
  oceanBlueColor,
  DodgerBlueColor,
} from "../../cmsMainStyle";

const circulationStyle = (theme) => ({
  circulationList: {
    height:
      window.outerHeight - (window.outerHeight - window.innerHeight + 370),
    overflowY: "auto",
    overflowX: "hidden",
  },

  circculationContentArea: {
    // height: window.outerHeight - (window.outerHeight - window.innerHeight + 230),
    height:
      window.outerHeight - (window.outerHeight - window.innerHeight + 335),
    overflowY: "auto",
    overflowX: "hidden",

    marginTop: theme.spacing(1),
  },

  circulationCard: {
    width: "100%",
    background:
      "linear-gradient(0deg, " + whiteColor + ", " + DodgerBlueColor[0] + ")",
    cursor: "pointer",

    "&:hover": {
      background:
        "linear-gradient(0deg, " + whiteColor + ", " + oceanBlueColor[3] + ")",
    },

    // '&:active': {
    // 	background:	"linear-gradient(0deg, " + whiteColor + ", " + DodgerBlueColor[3] + ")",
    // },

    // '&:focus': {
    // 	background:	"linear-gradient(0deg, " + whiteColor + ", " + DodgerBlueColor[3] + ")",
    // }
  },

  circulationNewBtn: {
    width: "100%",
    marginBottom: theme.spacing(1),
    background: oceanBlueColor[7],

    "&:hover": {
      backgroundColor: oceanBlueColor[12],
    },
  },

  avatar: {
    backgroundColor: "var(--avatar-color)",
  },

  readedIcon: {
    color: oceanBlueColor[7],
  },

  unreadIcon: {
    color: oceanBlueColor[12],
  },

  messageBtn: {
    "&:hover": {
      backgroundColor: oceanBlueColor[12],
    },

    background: oceanBlueColor[7],
    marginRight: theme.spacing(2),
  },

  messageCode: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  messageSubject: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  messageContent: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },

  messageRecipient: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),

    // marginBotton: theme.spacing(1),
  },

  messageRecipientArea: {
    minHeight: theme.spacing(5),

    "& > *": {
      margin: theme.spacing(0.5),
    },
  },

  messageAttachment: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  messageAttachmentArea: {
    minHeight: theme.spacing(5),

    "& > *": {
      margin: theme.spacing(0.5),
    },

    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },

  contentTopLine: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
  },

  contentBottomLine: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  masterArea: {
    "& > *": {
      minHeight: theme.spacing(10),
      padding: theme.spacing(2),

      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },

  replyArea: {
    "& > *": {
      minHeight: theme.spacing(10),

      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(2),

      padding: theme.spacing(2),
    },
  },

  filterButtonGroup: {
    width: "100%",
    marginBottom: theme.spacing(1),
  },

  filterButton: {
    width: "33.4%",
    color: "black",
  },

  popoverMain: {
    padding: theme.spacing(2),
  },

  popoverMember: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  listMsg: {
    display: "flex",
    justifyContent: "center",
    paddingTop: theme.spacing(1),
  },

  listSubject: {
    width: window.screen.width * 0.2,
  },

  circulationPagination: {
    display: "flex",
    justifyContent: "center",

    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  circulationBadge: {
    backgroundColor: oceanBlueColor[8],
    color: "white",
  },
});

export { circulationStyle };
